import { useCallback } from 'react'

import { Button, FixedBanner, Heading } from '@circlefin/components'
import { FullScreen } from '@modals/layout'
import { homeSection } from '@services/sections/lib/home'
import { Center } from '@shared/components/layout'
import { useRouter } from 'next/router'
import useTranslation from 'next-translate/useTranslation'

export const Success: React.FC = () => {
  const { t } = useTranslation('ace')
  const router = useRouter()

  const handleCtaClick = useCallback(() => {
    void router.push(homeSection.route)
  }, [router])

  return (
    <FullScreen totalSteps={2}>
      <Center className="flex flex-col justify-items-center">
        <Heading
          alignment="center"
          iconName="CheckCircleSolid"
          layout="vertical"
          status="success"
          variant="page/sm"
        >
          <Heading.Header as="h2">
            {t(`sendOnchain.success.heading`)}
          </Heading.Header>
          <Heading.Intro as="p">
            {t(`sendOnchain.success.subheading`)}
          </Heading.Intro>
        </Heading>

        <FixedBanner className="mt-12 w-fit" status="info" visible>
          <FixedBanner.Description>
            {t(`sendOnchain.success.banner.description`)}
          </FixedBanner.Description>
        </FixedBanner>

        <Button className="mt-12" onClick={handleCtaClick} variant="primary">
          {t(`sendOnchain.success.cta`)}
        </Button>
      </Center>
    </FullScreen>
  )
}
